$(document).ready(function () {
	var allShopSections = document.querySelectorAll('.fb-slider-init');

	allShopSections.forEach((section) => {

		var shopGalleryThumbs = section.querySelector(".wls-shop__gallery-thumbs");
		if (shopGalleryThumbs) {
			var slickArrow = '<button type="button" class="slick-arrow slick-prev"><svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg></button>';
			var slickArrowNext = '<button type="button" class="slick-arrow slick-next"><svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg></button>';
			var mainGallery = $(section).find(".wls-shop__gallery-main").slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				loop: true,
				dots: false,
				arrows: true,
				prevArrow: slickArrow,
				nextArrow: slickArrowNext,
				fade: true,
				asNavFor: $(section).find(".wls-shop__gallery-thumbs"),
				responsive: [
					{
						breakpoint: 768,
						settings: {
							dots: false
						}
					}
				]
			});

			var thumbsGallery = $(section).find(".wls-shop__gallery-thumbs").slick({
				slidesToShow: 8,
				slidesToScroll: 1,
				asNavFor: $(section).find(".wls-shop__gallery-main"),
				dots: false,
				arrows: true,
				prevArrow: slickArrow,
				nextArrow: slickArrowNext,
				focusOnSelect: true,
				variableWidth: true,
				responsive: [
					{
						breakpoint: 1025,   // 1025 → 768
						settings: {
							slidesToShow: 6
						}
					},
					{
						breakpoint: 990,   // 1025 → 768
						settings: {
							slidesToShow: 12
						}
					},
					{
						breakpoint: 768,    // 767 → 0
						settings: {
							slidesToShow: 5
						}
					}
				]
			});

			// Function to play or pause the video
			function toggleVideoPlayback(videoElement) {
				if (videoElement.paused) {
					videoElement.play();
				} else {
					videoElement.pause();
				}
			}

			mainGallery.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
				var currentSlideVideo = $(section).find(".wls-shop__gallery-main .slick-slide[data-slick-index='" + currentSlide + "'] video");
				if (currentSlideVideo.length > 0) {
					currentSlideVideo.get(0).pause();
				}
			});

			mainGallery.on('afterChange', function (event, slick, currentSlide) {
				var currentSlideVideo = $(section).find(".wls-shop__gallery-main .slick-slide").not('.slick-cloned').eq(currentSlide).find('video');
				if (currentSlideVideo.length > 0) {
					currentSlideVideo.get(0).play().catch(function () {});
				}
			});

			// Play or pause the video when clicking on a thumbnail based on whether it's a video slide
			thumbsGallery.on('click', '.slick-slide', function () {
				var clickedVideo = $(".wls-shop__gallery-main .slick-slide[data-slick-index='" + $(this).data('slick-index') + "'] video");
				if (clickedVideo.length > 0) {
					toggleVideoPlayback(clickedVideo.get(0));
				}
			});

			// Play or pause the video when clicking on the previous arrow
			$(".wls-shop__arrow-prev").on('click', function () {
				var currentSlide = mainGallery.slick('slickCurrentSlide');
				var currentSlideVideo = $(".wls-shop__gallery-main .slick-slide[data-slick-index='" + currentSlide + "'] video");
				if (currentSlideVideo.length > 0) {
					toggleVideoPlayback(currentSlideVideo.get(0));
				}
			});

			// Play or pause the video when clicking on the next arrow
			$(".wls-shop__arrow-next").on('click', function () {
				var currentSlide = mainGallery.slick('slickCurrentSlide');
				var currentSlideVideo = $(".wls-shop__gallery-main .slick-slide[data-slick-index='" + currentSlide + "'] video");
				if (currentSlideVideo.length > 0) {
					toggleVideoPlayback(currentSlideVideo.get(0));
				}
			});

			$(section).on('click', '.gallery-video, .wls-gallery-video-btn', function (e) {
				e.preventDefault();
				e.stopPropagation();
				var videoSlideIndex = -1;
				$(section).find('.wls-shop__gallery-main .slick-slide').not('.slick-cloned').each(function (index, slide) {
					if ($(slide).find('video').length > 0) {
						videoSlideIndex = index;
						return false;
					}
				});
				if (videoSlideIndex !== -1) {
					mainGallery.slick('slickGoTo', videoSlideIndex);
				}
			});
		}

		var sellingPriceMain = section.querySelector(".selling-price");
		var sellingPrice = section.querySelector(".wls-shop__selling-price");
		if (sellingPrice && sellingPriceMain) {
			sellingPriceMain.appendChild(sellingPrice);
		}

	});
});